export const BLOQUE_DEVIS = '#FFD0E0';
export const OPTION = '#FFEA76';
export const FACTURE = '#FFAFFF';
export const BLOQUE_COMMANDE = '#FF7979';
export const LIBRE = '#FFFFFF';
export const EN_ATTENTE = '#90C7FF';
export const VERT = '#90FFB9';
export const BLUE = '#90C7FF';
export const BLANC = '#FFFFFF';
export const JAUNE = '#F0FF90';
export const ORANGE = '#FFA500';
export const ROUGE = '#FF5E5E';
